import Carousel from 'react-multi-carousel'
import styled from 'styled-components'

export const CarouselContainer = styled(Carousel)`
  display: flex;
  flex-wrap: nowrap;
  width: 100%;

  li {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
